export default {
  getBusinessConfig: {
    url: '/business_config',
    method: 'get',
    desc: '获取设置信息'
  },
  setBusinessConfig: {
    url: '/business_config',
    method: 'post',
    desc: '保存设置信息'
  },
  setForecastConfigStatus: {
    url: '/replenishment/set_forecast_config_status',
    method: 'get',
    desc: '修改某配置的状态，启用或者停用',
  },
  salesForecastConfig: {
    url: '/replenishment/sales_forecast_config',
    method: 'get',
    desc: '获取日销配置列表',
  },
  deleteForecastConfig: {
    url: '/replenishment/delete_forecast_config',
    method: 'get',
    desc: '删除某配置',
  },
  setForecastConfigDefault: {
    url: '/replenishment/set_forecast_config_default',
    method: 'get',
    desc: '将某配置设置为默认配置',
  },
  saveSalesForecastConfig: {
    url: '/replenishment/save_sales_forecast_config',
    method: 'post',
    desc: '保存日销配置信息',
  },
  platformStockUpConfig: {
    url: '/replenishment/platform_stock_up_config',
    method: 'get',
    desc: 'FBA补货_备货规则列表查询',
  },
  savePlatformStockUpConfig: {
    url: '/replenishment/save_platform_stock_up_config',
    method: 'post',
    desc: '保存备货规则信息',
  },
  setPlatformStockUpConfigDefault: {
    url: '/replenishment/set_platform_stock_up_config_default',
    method: 'get',
    desc: '将某备货规则设置为默认配置',
  },
  setPlatformStockUpConfigStatus: {
    url: '/replenishment/set_platform_stock_up_config_status',
    method: 'get',
    desc: '修改某备货规则的状态，启用或者停用',
  },
  deletePlatformStockUpConfig: {
    url: '/replenishment/delete_platform_stock_up_config',
    method: 'get',
    desc: '删除某备货规则',
  },
}
